import fgInput from "./components/Inputs/formGroupInput.vue";
import DropDown from "./components/Dropdown.vue";
import Card from "./components/Cards/Card.vue";
import Button from "./components/Button.vue";
import Switch from "./components/Switch.vue";
import VueSweetalert2 from "vue-sweetalert2";
import VueScrollTo from "vue-scrollto";
import VueLoadingOverlay from "vue-loading-overlay";
import Chart from "chart.js";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import VueBootstrapTypeahead from "vue-bootstrap-typeahead";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";

import "vue-loading-overlay/dist/vue-loading.css";

Chart.defaults.global.defaultFontFamily =
  '"Montserrat", "Helvetica Neue", Arial, sans-serif';

const GlobalComponents = {
  install(Vue) {
    Vue.component("fg-input", fgInput);
    Vue.component("drop-down", DropDown);
    Vue.component("card", Card);
    Vue.component("n-button", Button);
    Vue.component("n-switch", Switch);
    Vue.component("VueCtkDateTimePicker", VueCtkDateTimePicker);
    Vue.component("vue-bootstrap-typeahead", VueBootstrapTypeahead);
    Vue.use(VueSweetalert2, {
      // TODO finish custom classes for sweetalert
      buttonsStyling: false,
      customClass: {
        confirmButton: "btn btn-round btn-primary",
        cancelButton: "btn btn-round btn-default",
        closeButton: "btn btn-round btn-default"
      }
    });
    Vue.use(VueScrollTo, {
      container: "body",
      duration: 500,
      easing: "ease",
      offset: 0,
      force: true,
      cancelable: true,
      onStart: false,
      onDone: false,
      onCancel: false,
      x: false,
      y: true
    });
    Vue.use(VueLoadingOverlay, {
      color: "#1E3C72",
      container: null,
      loader: "bars"
    });
  }
};

export default GlobalComponents;
